// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".equipment-detail {\n  padding: 24px 44px;\n}\n.equipment-detail .links {\n  padding-left: 24px;\n}\n.equipment-detail .links .q-card {\n  height: 230px;\n  overflow: hidden;\n  overflow-y: auto;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
